import { ICoachingComment, ICoachingPendingCompletion } from "../modules/coaching/store/types";

/** A comment authored offline and still awaiting its first/next sync attempt. */
export function isPendingComment(comment: ICoachingComment): boolean {
    return comment.modified === "Add" && comment.syncStatus === "pending";
}

/** A completion enqueued offline and still awaiting sync. */
export function isPendingCompletion(record: ICoachingPendingCompletion): boolean {
    return record.modified === "Add" && record.syncStatus === "pending";
}
